export enum BillingPeriodEnum {
  monthly = 'monthly',
  annual = 'annual',
}

export enum SubscriptionPeriodEnum {
  month = 'month',
  year = 'year',
}

export const BillingPeriodCaptionEnum = {
  [BillingPeriodEnum.monthly]: 'dashboard.name_of_times.months.one',
  [BillingPeriodEnum.annual]: 'dashboard.name_of_times.years.one',
}
